import { Navigate, Route, Routes } from 'react-router-dom';
import { DatosScreen } from '../components/datos/DatosScreen';
import { GasolineraList } from '../components/datos/GasolineraList';
import { NuevoVehiculo } from '../components/datos/NuevoVehiculo';
import { FacturasScreen } from '../components/facturas/FacturasScreen';
import { Error404Screen } from '../components/feedback/Error404Screen';
import { PromocionesScreen } from '../components/promociones/PromocionesScreen';
import { RepostajesScreen } from '../components/repostajes/RepostajesScreen';
import { FlotasScreen } from '../components/flotas/FlotasScreen';
import { AyudaScreen } from '../components/ayuda/AyudaScreen';
import { DatosFacturacion } from '../components/facturas/DatosFacturacionScreen';
import { FormDatosFacturacionScreen } from '../components/facturas/FormDatosFacturacionScreen';
import { RegistroVehiculoScreen } from '../components/flotas/registro-vehiculo/RegistroVehiculoScreen';
import { HistorialPagos } from '../components/flotas/pago/HistorialPagos';
import { AgregarSaldoScreen } from '../components/flotas/agregar-saldo/AgregarSaldoScreen';
import { useLocalizedRoutes } from '../hooks/useLocalizedRoutes';

export const DashboardRoutes = () => {
  const { getPath } = useLocalizedRoutes();

  return (
    <Routes>
      <Route path='/' element={<Navigate to={getPath('home')} replace />} />
      <Route path={getPath('home')} element={<DatosScreen />} />
      <Route path={getPath('invoices')} element={<FacturasScreen />} />
      <Route path={getPath('refuelings')} element={<RepostajesScreen />} />
      <Route path={getPath('promotions')} element={<PromocionesScreen />} />
      <Route path={getPath('newVehicle')} element={<NuevoVehiculo />} />
      <Route path={getPath('gasStations')} element={<GasolineraList />} />
      <Route path={getPath('billingData')} element={<DatosFacturacion />} />
      <Route
        path={getPath('billingNew')}
        element={<FormDatosFacturacionScreen mode='new' />}
      />
      <Route
        path={getPath('billingEdit')}
        element={<FormDatosFacturacionScreen mode='edit' />}
      />
      <Route path={getPath('fleetsMyFleets')} element={<FlotasScreen />} />
      <Route path={getPath('fleetsHistory')} element={<HistorialPagos />} />
      <Route
        path={getPath('fleetsNewVehicle')}
        element={<RegistroVehiculoScreen />}
      />
      <Route
        path={getPath('fleetsAddBalance')}
        element={<AgregarSaldoScreen />}
      />
      <Route path={getPath('help')} element={<AyudaScreen />} />
      <Route
        path={getPath('login')}
        element={<Navigate to={getPath('home')} replace />}
      />
      <Route
        path={getPath('register')}
        element={<Navigate to={getPath('home')} replace />}
      />
      <Route
        path={getPath('registerVerify')}
        element={<Navigate to={getPath('home')} replace />}
      />
      <Route
        path={getPath('recovery')}
        element={<Navigate to={getPath('home')} replace />}
      />
      <Route path='*' element={<Error404Screen />} />
    </Routes>
  );
};
